import { createSlice } from '@reduxjs/toolkit';

const approveSlice = createSlice({
  name: 'approveSlice',
  initialState: {
    approve: [],
    totalRowCount: 0,
    isApproveLoading: false,
  },
  reducers: {
    setApprove: (state, action) => {
      state.approve = action.payload.data.approve;
      state.totalRowCount = action.payload.data.totalRowCount;
    },
    setApproveLoading: (state, action) => {
      state.isApproveLoading = action.payload;
    },
  },
});

export const { setApprove, setApproveLoading } = approveSlice.actions;
export default approveSlice.reducer;
